import { render, staticRenderFns } from "./fourthPage.vue?vue&type=template&id=056aee8a&scoped=true"
import script from "./fourthPage.vue?vue&type=script&lang=js"
export * from "./fourthPage.vue?vue&type=script&lang=js"
import style0 from "./fourthPage.vue?vue&type=style&index=0&id=056aee8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056aee8a",
  null
  
)

export default component.exports